import React, { createContext, useContext, useState } from "react";
import { StartAssetMonitoring, StopAssetMonitoring } from "../cuas/assetUtil";

export const CuasContext = createContext();

export function useCuas() {
    return useContext(CuasContext);
}

export function CuasProvider({ children }) {
    const [assetMonitors, setAssetMonitors] = useState([]);

    const getAssetMonitor = (assetUUID) => {
        return assetMonitors.find((m) => m.getId() === `${assetUUID}-monitor`);
    };

    const isAssetMonitoring = (assetUUID) => {
        return !!getAssetMonitor(assetUUID);
    };

    const startAssetMonitoring = (map, assetUUID) => {
        const assetMonitor = StartAssetMonitoring(map, assetUUID);
        if (!assetMonitor) {
            return;
        }
        assetMonitor.on("propertychange", () => {
            const clone = assetMonitor.clone();
            clone.setId(assetMonitor.getId());
            setAssetMonitors((prev) => [...prev.filter((feature) => feature.getId() !== assetMonitor.getId()), clone]);
        });
        setAssetMonitors((prev) => [...prev, assetMonitor]);
    };

    const stopAssetMonitoring = async (map, assetUUID) => {
        const assetMonitor = await StopAssetMonitoring(map, assetUUID);
        if (assetMonitor) {
            setAssetMonitors((prev) => prev.filter((feature) => feature.getId() !== assetMonitor.getId()));
        }
    };

    const value = {
        assetMonitors,
        isAssetMonitoring,
        getAssetMonitor,
        startAssetMonitoring,
        stopAssetMonitoring
    };

    return <CuasContext.Provider value={value}>{children}</CuasContext.Provider>;
}
